import {createAction, createReducer} from 'redux-act';

export const initialState = false;

/** Action which puts the state of what it is try on view */
export const setTryOnViewShow = createAction<boolean>('SET_TRY_ON_VIEW_SHOW');

/** Action which says to need update faces on try on view */
export const updateTryOnViewFaces = createAction('UPDATE_TRY_ON_VIEW_FACES');

/**
 * The reducer sets the state which tells the application that it is currently in use tryOnView.
 */
export const isLoadFromCategory = createReducer<boolean>({}, initialState).on(
    setTryOnViewShow,
    (state: boolean, payload: boolean): boolean => payload,
);
